import { render, staticRenderFns } from "./customItem.vue?vue&type=template&id=73199afd&scoped=true&"
import script from "./customItem.vue?vue&type=script&lang=js&"
export * from "./customItem.vue?vue&type=script&lang=js&"
import style0 from "./customItem.vue?vue&type=style&index=0&id=73199afd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73199afd",
  null
  
)

export default component.exports